<template>
  <div class="plan-item">
    <div class="file">
      <button @click="goActivity">
        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0V18H5.53846V16.6154H1.38462V1.38462H8.30769V5.53846H12.4615V9.69231H13.8462V4.5595L9.28666 0H0ZM9.69231 2.36358L11.4826 4.15385H9.69231V2.36358ZM12.4615 11.0769V18H13.8462V11.0769H12.4615ZM9.69231 13.1538V18H11.0769V13.1538H9.69231ZM6.92308 15.2308V18H8.30769V15.2308H6.92308Z" fill="#00465B"/>
        </svg>
      </button>
      <div class="file-name">{{student.name}}</div>
    </div>
    <div class="items">
<!--      <button :style="plan.stonks ?   '' : ' background: #8CC63F'" >-->
<!--        <svg  width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <path :style="plan.stonks ?   'fill:#787878;' : ' fill:white'"   d="M1.82699 0V1.33333H4.24716L0 5.52865L0.954358 6.47135L5.20152 2.27604V4.66667H6.55133V0H1.82699ZM12.6255 0C11.5153 0 10.6008 0.903353 10.6008 2C10.6008 3.09665 11.5153 4 12.6255 4C13.7357 4 14.6502 3.09665 14.6502 2C14.6502 0.903353 13.7357 0 12.6255 0ZM12.6255 1.33333C13.0068 1.33333 13.3004 1.62331 13.3004 2C13.3004 2.37669 13.0068 2.66667 12.6255 2.66667C12.2441 2.66667 11.9506 2.37669 11.9506 2C11.9506 1.62331 12.2441 1.33333 12.6255 1.33333ZM11.9506 4.66667C10.4617 4.66667 9.25095 5.86267 9.25095 7.33333V10.832L10.6008 11.4987V16H11.9506V10.6758L10.6008 10.0091V7.33333C10.6008 6.598 11.2061 6 11.9506 6H13.3004C14.0448 6 14.6502 6.598 14.6502 7.33333V10.0091L13.3004 10.6758V16H14.6502V11.4987L16 10.832V7.33333C16 5.86267 14.7892 4.66667 13.3004 4.66667H11.9506ZM6.55133 8V16H7.90114V8H6.55133ZM3.85171 10.6667V16H5.20152V10.6667H3.85171ZM1.15208 13.3333V16H2.50189V13.3333H1.15208Z"  />-->
<!--        </svg>-->
<!--      </button>-->
      <button @click="goGift()" :style="(this.student.category_details!==null ? this.student.category_details.isTeacher===0  : true  )?   'border: 1px solid #8CC63F' : ' background: #8CC63F'">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path :style="(this.student.category_details!==null ? this.student.category_details.isTeacher===0  : true  )?  'fill:#8CC63F' : ' fill:white'" d="M3.77083 0C3.1276 0 2.64844 0.214844 2.36458 0.552083C2.08073 0.889323 2 1.30859 2 1.66667C2 2.51823 2.46094 3.20964 3.09375 3.65625C3.28906 3.79427 3.49609 3.90365 3.71875 4H0V7.66667H0.666667V16H15.3333V7.66667H16V4H12.2812C12.5039 3.90365 12.7109 3.79427 12.9062 3.65625C13.5391 3.20964 14 2.51823 14 1.66667C14 1.30859 13.9193 0.889323 13.6354 0.552083C13.3516 0.214844 12.8724 0 12.2292 0C11.5638 0 11.026 0.28125 10.625 0.666667C10.224 1.05208 9.9362 1.53776 9.66667 2C9.39714 2.46224 9.14323 2.90625 8.875 3.20833C8.60677 3.51042 8.36198 3.66667 8 3.66667C7.63802 3.66667 7.39323 3.51042 7.125 3.20833C6.85677 2.90625 6.60286 2.46224 6.33333 2C6.0638 1.53776 5.77604 1.05208 5.375 0.666667C4.97396 0.28125 4.4362 0 3.77083 0ZM3.77083 0.666667C4.25911 0.666667 4.59245 0.84375 4.90625 1.14583C5.22005 1.44792 5.49609 1.87891 5.76042 2.33333C6.02474 2.78776 6.28385 3.26042 6.625 3.64583C6.63151 3.65365 6.63932 3.65885 6.64583 3.66667H5.33333C4.66146 3.66667 3.96745 3.46615 3.46875 3.11458C2.97005 2.76302 2.66667 2.28776 2.66667 1.66667C2.66667 1.41536 2.72656 1.16667 2.875 0.989583C3.02344 0.8125 3.26693 0.666667 3.77083 0.666667ZM12.2292 0.666667C12.7331 0.666667 12.9766 0.8125 13.125 0.989583C13.2734 1.16667 13.3333 1.41536 13.3333 1.66667C13.3333 2.28776 13.0299 2.76302 12.5312 3.11458C12.0326 3.46615 11.3385 3.66667 10.6667 3.66667H9.35417C9.36068 3.65885 9.36849 3.65365 9.375 3.64583C9.71615 3.26042 9.97526 2.78776 10.2396 2.33333C10.5039 1.87891 10.7799 1.44792 11.0938 1.14583C11.4076 0.84375 11.7409 0.666667 12.2292 0.666667ZM0.666667 4.66667H6V7H0.666667V4.66667ZM6.66667 4.66667H9.33333V7.27083C9.33333 7.28125 9.33333 7.29167 9.33333 7.30208C9.33333 7.3125 9.33333 7.32292 9.33333 7.33333C9.33073 7.35807 9.33073 7.38151 9.33333 7.40625V15.3333H6.66667V7.39583C6.66927 7.375 6.66927 7.35417 6.66667 7.33333C6.66797 7.31901 6.66797 7.30599 6.66667 7.29167C6.66667 7.28125 6.66667 7.27083 6.66667 7.26042V4.66667ZM10 4.66667H15.3333V7H10V4.66667ZM1.33333 7.66667H6V15.3333H1.33333V7.66667ZM10 7.66667H14.6667V15.3333H10V7.66667Z" fill="white"/>
        </svg>
      </button>
    </div>
    <div class="head"  >
      <span class="name">{{title}}</span>
      <span class="date"> {{(student.category_details && this.student.category_details.isTeacher=='1') ? date : ''}} </span>
    </div>


  </div>
</template>

<script>
export default {
  name: "PlanItem",
  props: {
    plan: {
      src: {},
      data: {},
      name: {},
      title: {},
      activated: {
        stonks: {},
        present: {},
      },
    },
    student: {}
  },
  computed: {
    date() {
      let ms = this.student.category_details.date * 1000;
      let date = new Date(ms);
       let day = date.getDate()> 9 ?   date.getDate() :  '0'+date.getDate();
       let month = date.getMonth()>9?  date.getMonth() : '0'+(date.getMonth()+1);
       let year = date.getFullYear();
       return  day + '.'+ month + '.' + year
    },
    title(){

        if(this.student.category_details) {
          if (this.student.category_details.type === 'user'){
            if (!this.student.category_details.isTeacher=='1'){
              return ' הותאם אישית ב '
            } else {
              return  ' התלמיד הגדיר מתנות '
            }
          } else {
            return ' התלמיד שינה ב'
          }
        } else {
          return ''
        }
    }
  },
  methods: {
    goActivity() {
      this.$router.push({name: 'teacher-games-activity', params: {id: this.student.id_user}})
    },
    goGift() {
      this.$router.push({name: 'teacher-gifts', params: {id: this.student.id_user, name: 'אורי שבתאי '}})
    }
  },
}
</script>

<style scoped lang="scss">
  //
 .plan-item{
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: space-between;
   width: 100%;
   padding: 18px 0;
   border-bottom: 1px solid #C4C4C4;
   .head{
     width: 140px;
     font-style: italic;
     font-weight: normal;
     font-size: 12px;
     color: #C4C4C4;
     text-align: center;

     .name{

     }
     .date{

     }
   }
  .items{
    display: flex;
    flex-direction: row;
    button{
      margin: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      background: white;
      @media screen and (max-width: 330px) {
        margin: 0 3px;
      }
      svg{

      }
    }
  }
   .file{
     display: flex;
     align-items: center;
     width: 80px;
     .file-name{
       max-width: 130px;
       font-style: normal;
       font-weight: normal;
       font-size: 14px;
       text-align: center;
       color: #3FBCD4;
       display: inline-block;
     }
     button{

     }
   }
 }
</style>